import { TASKS_KEY } from 'phoenix2/state/content/reducers';
import { IImmutableTask, IImmutableTaskItem } from 'phoenix2/state/sparxweb/apis/content.types';
import { parseTaskItemID } from 'phoenix2/utils/task';
import { makeTaskID } from '../sparxweb/apis/content';

export const getTask = (state: any, taskId: string): IImmutableTask | undefined =>
    state.getIn([TASKS_KEY, taskId]);

export const getTaskItem = (state: any, taskItemId: string): IImmutableTaskItem | undefined => {
    const taskId = makeTaskID(parseTaskItemID(taskItemId));
    const task = getTask(state, taskId);
    return task?.get('items').find(item => item?.get('id') === taskItemId);
};
